<template>
    <a
        v-bind="$attrs"
        class="search-result-item"
        :data-bot="context ? `search-result__product--${context}` : 'search-result__product'"
        :class="classes"
        :href="link"
        @mouseenter="handleMouseEnter"
        @mouseleave="isHovered = false"
    >
        <CompassObject size="extra-small" type="object" object="product" />
        <div class="search-result-item__content">
            <h5
                class="search-result-item__name typographies-paragraph-medium-black"
                v-html="number"
            />
            <p class="search-result-item__details typographies-paragraph-medium-regular">
                <span>{{ id }}</span>
                <span v-if="name" v-html="name" />
            </p>
            <div
                v-if="description"
                class="search-result-item__description typographies-paragraph-medium-regular"
                v-html="description"
            />
        </div>
    </a>
</template>
<script>
import SearchResultsGeneric from './SearchResultsGeneric.vue';

export default {
    extends: SearchResultsGeneric,
    props: {
        description: {
            type: String,
            default: '',
        },
        id: {
            type: Number,
            required: true,
        },
        name: {
            type: String,
            default: '',
        },
        number: {
            type: String,
            required: true,
        },
    },
    computed: {
        classes() {
            return {
                'search-result-item--is-hovered': this.isHovered,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.search-result-item {
    align-items: flex-start;
    cursor: pointer;
    display: flex;
    gap: var(--spacing-1);
    max-width: initial;
    padding: var(--spacing-1) var(--spacing-3);

    &--is-hovered {
        background: var(--colors-common-background-hover, #f6f6f9);
    }

    &__name {
        color: var(--colors-common-text-standard-default, #111);
        margin: 0;
    }

    &__content {
        min-width: 0;
    }

    &__details {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-2);
        margin: var(--spacing-0) 0 0;
    }

    &__description {
        color: var(--colors-common-text-subtle-default, #565665);
        margin: var(--spacing-0) 0 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    :deep(.highlight) {
        background: var(--colors-common-background-highlight-search);
    }
}
</style>
